import React, { useEffect, useState } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;

const ClientQuestions = () => {
  const [questions, setQuestions] = useState([]);
  const [form, setForm] = useState({ session_date: '', questions: '', objectives: '', context: '' });
  const [success, setSuccess] = useState('');
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    loadQuestions();
  }, []);

  const loadQuestions = () => {
    axios.get(`${API}/api/portal/questions`, { withCredentials: true }).then(r => setQuestions(r.data)).catch(() => {});
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.questions.trim()) return;
    setSubmitting(true);
    try {
      await axios.post(`${API}/api/portal/questions`, form, { withCredentials: true });
      setSuccess('Questions submitted successfully!');
      setForm({ session_date: '', questions: '', objectives: '', context: '' });
      loadQuestions();
      setTimeout(() => setSuccess(''), 4000);
    } catch {
      setSuccess('');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div data-testid="client-questions">
      <h1 className="portal-page-title">Submit Questions</h1>
      <p className="portal-page-subtitle">Send your questions ahead of your next advisory session</p>

      <div className="portal-card">
        <h3>Pre-Session Question Form</h3>
        {success && <div className="portal-success" style={{ marginTop: '0.75rem' }}>{success}</div>}
        <form className="portal-form" style={{ marginTop: '1rem' }} onSubmit={handleSubmit} data-testid="question-form">
          <div>
            <label>Target Session Date (optional)</label>
            <input type="date" value={form.session_date} onChange={e => setForm(f => ({ ...f, session_date: e.target.value }))} />
          </div>
          <div>
            <label>Your Questions *</label>
            <textarea value={form.questions} onChange={e => setForm(f => ({ ...f, questions: e.target.value }))} placeholder="What would you like to discuss or get advice on?" required />
          </div>
          <div>
            <label>Session Objectives (optional)</label>
            <textarea value={form.objectives} onChange={e => setForm(f => ({ ...f, objectives: e.target.value }))} placeholder="What outcome are you hoping for from this session?" rows={3} />
          </div>
          <div>
            <label>Additional Context (optional)</label>
            <textarea value={form.context} onChange={e => setForm(f => ({ ...f, context: e.target.value }))} placeholder="Any background information that would help your advisor prepare" rows={3} />
          </div>
          <button type="submit" className="portal-btn portal-btn-primary" disabled={submitting} data-testid="submit-question-btn">{submitting ? 'Submitting...' : 'Submit Questions'}</button>
        </form>
      </div>

      {questions.length > 0 && (
        <div style={{ marginTop: '2rem' }}>
          <h3 style={{ color: '#1B2A4E', marginBottom: '1rem' }}>Previously Submitted</h3>
          {questions.map(q => (
            <div key={q.id} className="portal-card">
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <span className="portal-badge">{q.status}</span>
                <span style={{ fontSize: '0.82rem', color: '#5A6C8A' }}>{new Date(q.created_at).toLocaleDateString()}</span>
              </div>
              <p style={{ marginTop: '0.5rem' }}>{q.questions}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ClientQuestions;
